import {NgModule} from "@angular/core";
import {ContentComponent} from "./content.component";
import {CommonModule} from "@angular/common";
import {LoaderModule} from "../loader/loader.module";

@NgModule({
  declarations: [ContentComponent],
    imports: [CommonModule, LoaderModule],
  exports: [ContentComponent]
})
export class ContentModule { }
